export default {
  'Difficulty level': 'Schwierigkeitsgrad',
  'Your bet': 'Einsatzbetrag',
  'Start game': 'Spielen',
  'Take prize': 'Nehmen',
  'Try again': 'Versuch es noch einmal',
  Bet: 'Einsatz',
  Profit: 'Gewinn',
};
